/* @ngInject */
function formattedDateDayMonth () {
  return function (date) {
    if (!date) {
      return ''
    }

    const defaultFormat = 'DD MMM'

    const newDate = moment(date).format(defaultFormat)
    return newDate
  }
}

export { formattedDateDayMonth }
